import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { AmplifyProvider } from 'aws-auth-lib';
import { Provider } from 'react-redux';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

import App from './App';
import './global.css';
import { RoleProvider } from './utils/RoleContext';
import { awsAuthConfig } from './configs/aws';
import { reducer } from './store';

Amplify.configure(awsAuthConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));

const theme = createTheme({
    typography: {
        fontFamily: "'Cabin', sans-serif"
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: "'Cabin', sans-serif"
                }
            }
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    fontFamily: "'Cabin', sans-serif"
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontFamily: "'Arimo', sans-serif"
                },
                input: {
                    fontFamily: "'Arimo', sans-serif"
                }
            }
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    fontFamily: "'Arimo', sans-serif"
                }
            }
        }
    }
});

root.render(
    <AmplifyProvider config={awsAuthConfig}>
        <BrowserRouter>
            <Provider store={reducer}>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <RoleProvider>
                        <App />
                    </RoleProvider>
                </ThemeProvider>
            </Provider>
        </BrowserRouter>
    </AmplifyProvider>
);
